import $ from 'jquery';

export default {

	init() {


		// Open menu
		$('#hamburger').click(function(e) {

			$(this).addClass('hidden');
			$('#close-btn').removeClass('hidden').addClass('block');
			$(this).toggleClass('is-active');

			$('#header-mobile').slideToggle(function(e) {

				if($(this).is(':visible')) {
					$(".main-menu a").first().focus();
				}

			});

		});

		// Close menu
		$('#close-btn').click(function(e) {
			$(this).addClass('hidden');
			$('#hamburger').removeClass('hidden').addClass('block');
			$('#hamburger').removeClass('is-active').focus();

			$('#header-mobile').slideUp(function(e) {
				$('.hamburger').focus();
			});

		});

		//Scroll animation
		$(window).scroll(function() {
			var value = $(this).scrollTop();

			if(value > 0) {
				$(".js-scroll").addClass("shadow-md");
			} else {
				$(".js-scroll").removeClass("shadow-md");
			}
		});

		//Hide mobile menu on desktop
		$(window).on('resize', function() {
			var win = $(this);
			if(win.width() > 1024 && $('#header-mobile').is(':visible')) {
				$('#header-mobile').hide();
			}
		});

	}

};
